import React from 'react';
import cn from 'classnames';
import { Facet, FacetContent, RequestHandler } from 'festo-react-ui-kit';

import useTranslation from '../../features/translation/hooks/useTranslation';
import { getFacetValue, isPopupWithCheckbox } from './utils';
import { Filter } from '../../interfaces';
import InfoButtonContent from './InfoButtonContent';
import { useAppSelector } from '../../app/hooks';
import './FacetWrapper.scss';

interface FacetWrapperProps {
  onChange: (filterName: string, value: (string | number)[] | string | number) => void;
  visible: boolean;
  id: number;
  root?: boolean;
  filter: Filter;
}

const FacetWrapper: React.FC<FacetWrapperProps> = ({ onChange, visible, id, root, filter }) => {
  const { type, value, icon, expanded, hidden, key, label, unit } = filter;
  const { index: findex } = filter.configuration || {};
  const { language } = useAppSelector((state) => state.base);
  const t = useTranslation();
  const { applicationType } = new RequestHandler();
  const isFoxEnvironment = applicationType === 'fox';

  return (
    <>
      <Facet
        className={cn(
          'ems-facet',
          `ems-facet-${key}`,
          `facet--${type}`,
          { hidden: hidden },
          { 'ems-facet--no-index': type === 'mixbox' && !findex },
          { 'fox-slider-indicator': isFoxEnvironment },
        )}
        showInfoIcon={icon.visible && (icon.messageTranslationKey !== undefined || icon.imageSrc !== undefined)}
        popupContent={
          icon.visible &&
          icon.messageTranslationKey && <InfoButtonContent amountOfMessages={t(icon.messageTranslationKey)} />
        }
        title={t(label)}
        open={expanded}
        visible={visible}
        labelAsTitle
      >
        {value && (
          <FacetContent
            value={getFacetValue(value)}
            unit={t(unit ?? '')}
            id={id.toString() + label}
            type={type}
            onChange={(newValue): void => onChange(key, newValue)}
            locale={language}
            index={findex}
            className={cn({ 'ems-facet-content--root': root })}
          />
        )}
        {filter.filters &&
          filter.filters.length > 0 &&
          filter.filters.map((fil) => {
            return fil.value !== undefined && (fil.filterDisplayMode.type === 'CHILD' || isPopupWithCheckbox(fil)) ? (
              <FacetContent
                key={fil.label}
                value={getFacetValue(fil.value)}
                unit={t(unit ?? '')}
                id={t(fil.label)}
                locale={language}
                type={fil.type}
                onChange={(newValue): void => {
                  const currentValue = fil.value;
                  if (
                    (key === 'cushioningReaction' || key === 'additionalFunction') &&
                    currentValue !== undefined &&
                    Array.isArray(currentValue)
                  ) {
                    onChange(currentValue[0].data + '', newValue);
                  } else {
                    onChange(key, newValue);
                  }
                }}
                index={fil.configuration?.index}
                className={cn({ 'ems-facet-content--root': root })}
              />
            ) : null;
          })}
      </Facet>
    </>
  );
};

export default FacetWrapper;
